module.exports = __webpack_public_path__ + "static/media/_arrow_left.87ecb913.svg";